import PCCCertificateDisplay from "@/components/dashboard/PCCCertificateDisplay";

const PCCCertificateViewPage = () => {
    return (
        <div className="flex flex-col min-h-screen bg-off-white">
            <div className="w-full max-w-7xl mx-auto px-6 py-8">
                <PCCCertificateDisplay />
            </div>
        </div>
    );
};

export default PCCCertificateViewPage;

